var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",class:{ 'is-active': _vm.value }},[_c('div',{staticClass:"modal-background",on:{"click":function($event){return _vm.close()}}}),_c('div',{staticClass:"modal-content preview"},[_c(_vm.tag,{tag:"component",attrs:{"src":_vm.src,"frameBorder":"0"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }